import { showLinkField, showTextField } from '@core/jss-utils';

import type { Hero, HeroAppButton } from './../models/hero.model';

export const isMultiColumnLayout = (
  hero: Partial<Hero> | undefined,
  hasWidget: boolean
): boolean => {
  return hasWidget || !!hero?.mainImage;
};

export const getAppButtons = (
  hero: Partial<Hero> | undefined
): HeroAppButton[] | undefined => {
  if (!hero) {
    return undefined;
  }

  const { iosButton, androidButton } = hero;
  const buttons: HeroAppButton[] = [];

  if (iosButton?.value) {
    buttons.push({
      alt: 'Download de app in de App Store!',
      type: 'ios-app-store',
      src: 'assets/images/app-button-ios.svg',
      url: iosButton.value,
    });
  }

  if (androidButton?.value) {
    buttons.push({
      alt: 'Download de app op Google Play!',
      type: 'google-play-store',
      src: 'assets/images/app-button-android.svg',
      url: androidButton.value,
    });
  }

  return buttons.length ? buttons : undefined;
};

export const showButtonGroup = (hero?: Partial<Hero>): boolean => {
  const { primaryButton, secondaryButton, iosButton, androidButton } =
    hero ?? {};

  return (
    showLinkField(primaryButton) ||
    showLinkField(secondaryButton) ||
    showTextField(androidButton) ||
    showTextField(iosButton)
  );
};
